angular.module('unergie.main')
.controller('timetableListCtrl', ($scope, $location, $state, $uibModal, DataAccess, ReferencesService, Rules, AlertManager, TableGeneratorService, ErrorCatcher) => {
    let openResultModal
    $scope.timetables = {}
    $scope.timetables.refreshing = false
    $scope.timetables.instance = {}
    $scope.timetables.instance.page = () => 1
    $scope.timetables.instance.count = () => 25
    $scope.timetables.instance.sorting = () => ({ timetable_date: 'asc' })
    $scope.timetables.instance.filter = () => _.assign({ status: '!50,70,99', timetable_date: `<${moment().add(1, 'month').format('YYYY-MM')}` }, _.clone($location.search()))

    $scope.timetables.columns = {
        'id_contract': { label: 'Contract ID', mode: 'search_wildcard', length: 9 },
        'account.fullname': { label: 'Client', mode: 'search_wildcard' },
        'status': { label: 'Statut', mode: 'search_operator' },
        'month': { label: 'Mois', mode: 'search_operator' },
        'year': { label: 'Année', mode: 'search_operator' },
        'id_p_calendar': { label: 'Classe', mode: 'search_wildcard' },
        'contract_status': { label: 'Statut contrat', mode: 'search_operator' },
        'total_modified': { label: 'Montant', mode: 'search_operator' },
        'timetable_date': { label: 'Date', mode: 'search_operator' },
    }

    const transformData = function (data) {
        data.forEach((d) => (d.account.fullname = `${d.account.givenname} ${d.account.sn}`))
        return data
    }

    const refresh = () => TableGeneratorService.getTable($scope.timetables, 'timetables', 'payment,account', transformData)

    $scope.refresh = refresh
    refresh()

    $scope.isWarning = (timetable) => (timetable.status === 0) && moment(`${timetable.month}-${timetable.year}`, 'M-YYYY').isBefore(moment().startOf('month'))

    $scope.isNotEmpty = (obj) => obj && (Object.keys(obj).length !== 0)

    $scope.isActive = (state) => $state.is(state)

    ReferencesService.getRef('ttStatuses').then((mapping) => ($scope.ttStatuses = mapping))

    const monthes = []
    for (let i = 1; i < 10; i++) {
        const m = moment().add(-i, 'month').format('MM/YYYY')
        monthes.push({ value: m, label: m })
    }

    const templateRules = {
        month: monthes[0].label,
    }
    $scope.rulesFields = {
        month: {
            label: 'Mois',
            type: 'select',
            enum: monthes,
        },
    }
    const resetRulesPayload = () => ($scope.rulesPayload = angular.copy(templateRules))

    resetRulesPayload()

    $scope.callRules = function () {
        const monthDate = moment($scope.rulesPayload.month, 'MM/YYYY')
        const year = monthDate.get('year')
        const month = (monthDate.get('month')) + 1
        return Rules.monthlyBilling({ year, month, limit: 100 }).$promise.then((result) => {
            AlertManager.success('Génération lancée')
            refresh()
            return openResultModal(result) }).catch(ErrorCatcher)
    }


    openResultModal = function (result) {
        return $uibModal.open({
            animation: true,
            size: 'lg',
            controller: 'resultModalCtrl',
            templateUrl: '/states/resultModal/resultModal.html',
            resolve: {
                result() {
                    return {
                        processed: result.processed,
                        errors: result.errors,
                    }
                },
            },
        })
    }
})
